import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ResponseData } from "src/app/Model/Base/Response";
import { ConnectionTypeDocumentViewModel } from "src/app/Model/ConnectionTypeDocumentView.model";
import { CountryModel } from "src/app/Model/Country.model";
import { RequestStatusProcess } from "src/app/Model/RequestStatusProcess";
import { StateModel } from "src/app/Model/State.model";

import { BaseService } from "../Base/BaseService";


import { TrainingDocumentsModel } from 'src/app/Model/TrainingDocument.Model';
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
  providedIn: "root",
})
export class TrainingService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
    super(http, lsService,authService);
    this.Component = "TrainingService";
  }

  public async getListDocumentsTraining(requestcode){
    let Document: TrainingDocumentsModel[];
    let Data = {
      "RequestCode": requestcode,
      "Language" : this.lsService.getLSItem("language")
    }

    await this.PostData(Data,"Training","GetListDocumentsTraining").then((res) => {
      
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    
    return Document;

  }

  public async InsertRegistry(idFile,requestcode){
    let resp: RequestStatusProcess;
    let postData = {
      "IdRequest": 0,
      "IdFile": idFile,
      "RequestCode": requestcode
    }
    await this.PostData(postData,"Training","InsertDownloadRecord").then((res) => {
      
      if(res.head.status != 'False') {
        resp = JSON.parse(res.body.response);
      }
    });
    
    return resp;

  }

  public async SetValidateStatus(data){
    let Document: ConnectionTypeDocumentViewModel[];
    await this.PostData(data,"Document","GetConnectionDocumentById").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  } async getStates(){
    let states: StateModel[];
    await this.PostData("","State","Get").then((res) => {
      if(res.head.status) {
        states = JSON.parse(res.body.response);
      }
    });
    return states;
  }
  public async getCountries(){
    let states: CountryModel[];
    await this.PostData("","State","GetCountries").then((res) => {
      if(res.head.status) {
        states = JSON.parse(res.body.response);
      }
    });
    return states;
  }
  public async postState(state:StateModel){
    let response: ResponseData;
    await this.PostData(state,"State","Post").then((res) => {
      response=res;
    });
    return response;
  }
  public async disableState(state:StateModel){
    let response: ResponseData;
    await this.PostData(state,"State","Delete").then((res) => {
      response=res;
    });
    return response;
  }

  public async getTrainingFlowState(data) {
    let result: boolean;
    await this.PostData(data, "Training", "GetTrainingFlowState").then((res) => {
      if (res.head.status != 'False') {
        result = JSON.parse(res.body.response);
      }
    });
    return result;
  }

  public async getTrainingStatus(requestcode){
    let result: boolean;
    await this.PostData(requestcode, "Training", "GetTrainingStatus").then((res) => {
      if (res.head.status != 'False') {
        result = JSON.parse(res.body.response);
      }
    });
    return result;
  }

}
